import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const ConfirmDialog = ({
  visible,
  title,
  content,
  cancelBtnLabel,
  confirmBtnLabel,
  onConfirmClick,
  onCancelClick,
  onCloseClick
}) =>(
  <StandardModal
    title={title || 'Confirm'}
    visible={visible}
    onCloseClick={onCloseClick}>
    <div>{content || 'Do you want to continue?'}</div>
    <br />
    <div className="text-right">
      {onCancelClick
        ? <button
            type="button"
            className="btn btn-link"
            onClick={onCancelClick}>
            {cancelBtnLabel || 'Cancel'}
          </button>
        : null
      }
      {onConfirmClick
        ? <button
            type="button"
            className="btn btn-primary btn-lg"
            onClick={onConfirmClick}>
            {confirmBtnLabel || 'Confirm'}
          </button>
        : null
      }
    </div>
  </StandardModal>
);

ConfirmDialog.propTypes = {
  cancelBtnLabel: PropTypes.string,
  confirmBtnLabel: PropTypes.string,
  content: PropTypes.node,
  title: PropTypes.node,
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onConfirmClick: PropTypes.func,
  onCloseClick: PropTypes.func
};

ConfirmDialog.defaultProps = {
  content: null,
  title: '',
  visible: false,
  cancelBtnLabel: '',
  confirmBtnLabel: ''
};

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/features/shared/ConfirmDialog.jsx